import { CarrierParcelSchema } from "@redotech/redo-model/outbound-labels/parcel";
import * as z from "zod";
import { null as zNull } from "zod";
export const getCarrierParcels = {
  name: "getCarrierParcels" as const,
  input: zNull(),
  output: z.object({ carrierParcels: z.array(CarrierParcelSchema) }),
};
